module.exports = __webpack_public_path__ + "img/feature_buy_th.f9f81ba5.png";